import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { useSettings } from '../../../hooks/useSettings';
import confetti from 'canvas-confetti';

export const Congratulation = () => {

    const classes = useStyles();

	const  { settings } = useSettings(false);

	useEffect(() => {
		confetti({
			particleCount: 200,
			spread: 180,
			tartVelocity: 30,
			zIndex: 9999999999999
		});
	}, []);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1}}
            transition={{ duration: 1.5 }}
        >	
            <Grid container display='flex' justifyContent='center'>
                <Grid item xs={ 10 } sm={ 8 } md={ 8 } lg={ 8 } xl={ 6 } alignItems='center'>
					<h1 className={ classes.title }>{ convertirLetraMayus(settings?.msj_despedida_encuestas) }</h1>
                </Grid>
            </Grid>
			
        </motion.div>
    )
}

const useStyles = makeStyles({
	title: {
		color: '#fff',
		textAlign: 'center',
		margin: '50px 0px 0px 0px',
		letterSpacing: 1,

		'@media screen and (max-width: 568px)': {
			fontSize: '1.5rem'
		},
		'@media screen and (min-width: 768px)': {
			fontSize: '2rem'
		},
		'@media screen and (min-width: 1024px)': {
			fontSize: '2.5rem'
		}
	}
});